// RASK35 promo: −35% on yearly Creator / Creator Pro, keyed by API plan category.
// Display-only config — the actual coupon auto-applies at checkout via the Stripe
// price metadata (applied_coupon), so the advertised price matches the first-year charge.
export const PRICING_CARD_DISCOUNT = {
  creator: {
    code: 'RASK35',
    year: 0.35,
  },
  creator_pro: {
    code: 'RASK35',
    year: 0.35,
  },
};
